import { useQuery } from '@apollo/client';
import { useState } from 'react';
import { FilterActivities } from '../graphql/Query/roads';
import * as options from '../utility/Options';
import { _activities } from './useOptions';

export const useFilterOptions = () => {
  const [activitiesOptions, setActivities] = useState([]);
  const { loading } = useQuery(FilterActivities, {
    variables: {
      search: {
        sort: '',
        sortColumn: '',
        page: 1,
        q: '',
        perPage: 1000,
        type: '',
        status: 'ACTIVE'
      }
    },
    onCompleted: ({ listActivities }) => {
      const dataFormated = listActivities.docs.map((item) => ({
        value: item._id,
        label: item.name
      }));
      setActivities(() => [
        { value: '', label: 'Selecciona Actividad' },
        ...dataFormated
      ]);

      dataFormated.forEach((item) => {
        _activities.set(item.value, item);
      });
    }
  });

  const permissionsOptions = [
    { value: 'EMPTY', label: 'Filtrar por seccion' },
    ...options.permissionsOptions
  ];

  const statusOptions = [
    { value: 'EMPTY', label: 'Seleccionar Estado', number: 0 },
    { value: 'ACTIVE', label: 'Activo', number: 1 },
    { value: 'INACTIVE', label: 'Inactivo', number: 2 }
  ];

  const membershipOptions = [
    { value: 'EMPTY', label: 'Seleccionar Membresía' },
    ...options.membershipOptions
  ];

  const scheduledMembershipOptions = [
    { value: 'EMPTY', label: 'Seleccionar Membresía' },
    ...options.scheduledMembershipOptions
  ];

  const genderOptions = [
    { value: 'EMPTY', label: 'Filtrar por Género' },
    ...options.genderOptions
  ];

  // ** User filter options
  const typeOptions = [
    { value: '', label: 'Selecciona Tipo' },
    { value: 'video', label: 'Video' },
    { value: 'audio', label: 'Audio' },
    { value: 'form', label: 'Formulario' },
    { value: 'friends', label: 'Amigos' },
    { value: 'checklist', label: 'CheckList' }
  ];

  const pillarsOptions = [
    { value: 'EMPTY', label: 'Seleccionar Pilar', number: 0 },
    { value: 'EMOTIONS', label: 'Emociones', number: 1 },
    { value: 'PURPOSE', label: 'Sentido de Vida', number: 2 },
    { value: 'RELATIONS', label: 'Relaciones', number: 3 },
    { value: 'SELF_ESTEEM', label: 'Amor Propio', number: 4 },
    { value: 'TRANSFORMATION', label: 'Transformaciones', number: 5 }
  ];

  return {
    options: {
      statusOptions,
      permissionsOptions,
      membershipOptions,
      genderOptions,
      typeOptions,
      pillarsOptions,
      activitiesOptions,
      scheduledMembershipOptions
    },
    loading
  };
};
